// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"7bf1930a","222":"de25d7e7","510":"3a70647d","957":"5da6e58f"}[chunkId] + ".chunk.js";
};